export const dateTimeFormats = {
    HourMinuteFormat: 'h:mm a',
    MonthDayFormat: 'M/D',
    MonthDayYearFormat: 'M/DD/YYYY',
    MonthDayYearHourMinuteFormat: 'M/d/yyyy h:mm a',

 } as const;

 export const MessageStatusType = {
    delivered: "delivered",
    failed: "failed",
    sent:"sent",
    sending:"sending",
 } as const;

 export const MessageTypeConst = {
   Text: "Text",
   Broadcast: "Broadcast",
   Survey: "Survey",
   VideoCall: "VideoCall",
   PaymentReceived: "PaymentReceived",
   PaymentSent: "PaymentSent",
   PaymentCanceled: "PaymentCanceled",
   PaymentVoided: "PaymentVoided",
   Facebook: "Facebook",
   MergedText: "MergedText"
} as const;


 export const ConversationType = {
    All: {
        Display:"All",
        Value:"all"
    },
    UnRead: {
        Display:"Unread",
        Value:"unread"
    },
    Archive: {
        Display:"Archived",
        Value:"archive"
    }
 } as const;

 export const BroadcastType = {
    EMAIL:"EMAIL",
    MMS:"MMS",
    SMS:"SMS",
 } as const;

 
 export const SurveyConstants = {
    DefaultStartHour:"08",
    DefaultEndHour:"18",
 } as const;

 export const MemoMessageBodyLimit:number = 100;

 export const FeatureNames = {
   Dashboard: "dashboard",
   Broadcasts: "broadcasts",
   Messenger: "messages",
   Surveys: "surveys",
   Feedback: "survey-response",
   Customers: "customers",
   CustomerGroups: "customer-groups",
   Orders: "invoice",
   Settings: "settings",
   Tasks: "tasks",
   Inventory: "inventory",
   Deals: "deals",
   Payments: "payments",
   Automations: "automations"
 } as const;

export const MessagePaymentStatus  = {
   Pending : "Pending",
   Canceled : "Canceled",
   Completed :"Completed",
   PartiallyCompleted :"PartiallyCompleted",
   Voided  :"Voided",
} as const;

export const ApplicationPropertyNames = {
   showTextToPayInvoices:"ShowTextToPayInvoices",
   SocialTestDealers:"SocialTestDealers",
} as const;

export const OrderType = {
   SaleOrder: "SO",
   WorkOrder: "WO",
} as const;

export const AutoSyncSettingsSource = {
   Widget: 'Widget',
   Import: 'Import',
   Customers: 'Customers',
   Messenger: 'Messenger',
   Facebook: 'Facebook',
   Instagram: 'Instagram',
   Deals: 'Deals',
};

 export const ConfigConstants = {
   TinyMceApiKey: "api.textEditor",
} as const;

export const ConversationFilters = {
  facebook: "Facebook",
  instagram: "Instagram",
  myConversations: "My Conversations",
  text: "Text",
  unassigned: "Unassigned",
} as const;

export const SOCIAL_MESSAGE_EXPIRY_HOURS = 168; // 7 days in hours

export const HUMAN_AGENT_THRESHOLD_HOURS = 24; // 24 hours threshold for human agent tag

export const LOGIN_SOURCE = {
   DMS_INFINITY: 'DMS_INFINITY',
   DMS_IDEAL: 'DMS_IDEAL',
   DMS_ASPEN: 'DMS_ASPEN',
   DMS_DIS: 'DMS_DIS',
} as const;

export const LOGIN_SOURCE_KEY = 'Login_Source';

export type LoginSourceType = typeof LOGIN_SOURCE[keyof typeof LOGIN_SOURCE];
